export const column = [
    {
        label: '序号',
        prop: 'sortNum'
    },
    {
        label: '联系人姓名',
        prop: 'name'
    },
    {
        label: '联系人手机号',
        prop: 'phone'
    },
    {
        label: '单位名称',
        prop: 'unitName'
    },
    {
        label: '需求描述',
        prop: 'content'
    },
    {
        label: '邮箱',
        prop: 'email'
    },
    {
        label: '来源',
        prop: 'source'
    },
    {
        label: '备注',
        prop: 'remarks'
    },
]

export const sourceList = ['内训', '劳务派遣', '人事代理', '档案管理']